import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";

import "./ReadStatus.scss";

const ReadStatus = ({ isUnread, hasReplied }) => {
	const showReplied = hasReplied;
	const showUnread = isUnread && !showReplied;

	return (
		<div className={classnames({
			"messages-row-message-readstatus": true,
			"messages-row-message-readstatus--replied": showReplied,
			"messages-row-message-readstatus--unread": showUnread,
		})}>
			{showUnread &&
				<span
					className="messages-row-message-readstatus-circle"
					aria-label={_str("Unread")}
					data-tooltip={_str("Unread")}
					data-tooltip-padding={5}
				/>
			}
			{showReplied &&
				<i
					className="okicon i-replied"
					aria-label={_str("You've replied")}
					data-tooltip={_str("You've replied")}
					data-tooltip-padding={5}
				/>
			}
		</div>
	);
};

ReadStatus.propTypes = {
	isUnread: PropTypes.bool,
	hasReplied: PropTypes.bool,
};

ReadStatus.defaultProps = {
	isUnread: false,
	hasReplied: false,
};

export default ReadStatus;



// WEBPACK FOOTER //
// ./src/apps/messages/components/ReadStatus.jsx